import React, { useState } from "react";
import { Box, Tabs, Tab, Card, CardContent } from "@mui/material";

import RepricerManagementSubTab from "./Configuration/OttoCategoryProvision";
import MarginRulesSubTab from "./Configuration/MarginRules";

const TabPanel = ({ children, value, index, ...other }) => (
  <div
    role="tabpanel"
    hidden={value !== index}
    id={`repricer-tabpanel-${index}`}
    aria-labelledby={`repricer-tab-${index}`}
    {...other}
  >
    {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
  </div>
);

const OttoPriceSetterSubTab = () => {
  const [repricerSubTab, setRepricerSubTab] = useState(0);

  const handleRepricerSubTabChange = (event, newValue) => {
    setRepricerSubTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Card>
        <CardContent>
          <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
            <Tabs
              value={repricerSubTab}
              onChange={handleRepricerSubTabChange}
              aria-label="repricer tabs"
            >
              <Tab label="Category Provision" />
              <Tab label="Margin Rules" />
            </Tabs>
          </Box>

          {/* Category Provision Tab */}
          <TabPanel value={repricerSubTab} index={0}>
            <RepricerManagementSubTab />
          </TabPanel>

          {/* Margin Rules Tab */}
          <TabPanel value={repricerSubTab} index={1}>
            <MarginRulesSubTab />
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OttoPriceSetterSubTab;
